<template>
  <div class="ca-footer__copyright">
    <div class="ca-footer__copyright-row gap-size-5">
      <p class="ca-footer__copyright-text caption-large">{{ legalText }}</p>
      <Popover
        v-if="showLanguageSelector"
        :options="languageOptions"
        v-model:selected="selectedLanguage"
        :icon="IconInternacional"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Popover from "../../base/Popover.vue";
import IconInternacional from "@assets/internacional.svg";

const props = defineProps({
  legalText: {
    type: String,
    required: true,
  },
  languageOptions: {
    type: Array,
    required: true,
  },
  currentLanguage: {
    type: String,
    required: true,
  },
  showLanguageSelector: {
    type: Boolean,
    default: false,
  },
});

const selectedLanguage = ref(props.currentLanguage);
</script>

<style scoped lang="scss">
.ca-footer__copyright-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 1025px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.ca-footer__copyright-text {
  flex: 1 0 0;
  margin: 0;
  color: var(--ca-color-text-inverted);
}
</style>
